import React from 'react';

const features = [
  {
    title: 'Pan-India Outreach',
    description:
      'We are driving an extensive promotional campaign across 20 states, ensuring a diverse and high-quality visitor profile from every corner of the country.',
  },
  {
    title: 'Bridge 365 (The Deal Box)',
    description:
      'Revolutionize the way you network. Gain exclusive access to our pre-show platform, allowing you to schedule meetings, view catalogs, and close deals long before the physical event begins.',
  },
  {
    title: 'Targeted B2B Matchmaking',
    description:
      'Move beyond casual browsing. Our structured matchmaking environment ensures exhibitors meet the right buyers—vetted and ready for business.',
  },
  {
    title: 'Innovation Showcases',
    description:
      'Discover the latest in mobile hardware, wearable tech, and cutting-edge accessories from global and domestic leaders.',
  },
  {
    title: 'Strategic Location',
    description:
      'Hosted in the heart of the capital, the expo offers seamless accessibility for international delegates and domestic trade partners alike.',
  },
];

function KeyFeatures() {
  return (
    <section className="ma-features" aria-labelledby="key-features-title">
      <div className="ma-container">
        <h2 id="key-features-title" className="ma-features-title">
          Key Features &amp; Highlights
        </h2>

        <div className="ma-features-grid">
          {features.map((feature, index) => (
            <article
              key={feature.title}
              className={`ma-feature-card${index >= 3 ? ' ma-feature-card--bottom' : ''}`}
            >
              <span className="ma-feature-accent" aria-hidden="true" />
              <h3 className="ma-feature-card-title">{feature.title}</h3>
              <p className="ma-feature-card-text">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default KeyFeatures;
